/**
 * Centralized SPA destinations — avoid scattered string paths.
 * Paths must match TanStack routes in router.tsx.
 */
export const routes = {
  dashboard: '/dashboard',
  items: '/items',
  orders: '/orders',
  dispatchLiveTracking: '/dispatch-management/live-tracking',
  dispatchOrders: '/dispatch-management/orders',
  stores: '/stores',
  customers: '/customers',
  deliverymen: '/deliverymen',
  refunds: '/refunds',
  reports: '/reports',
  settings: '/settings',
  settingsBusiness: '/settings/business',
} as const;

export type OrderStatusQuery =
  | 'all'
  | 'searching_for_deliverymen'
  | 'accepted'
  | 'processing'
  | 'item_on_the_way'
  | 'delivered'
  | 'canceled'
  | 'refunded'
  | 'failed'
  | 'pending'
  | 'scheduled';

export function ordersWithStatus(status: OrderStatusQuery) {
  return { to: routes.orders as never, search: { status, page: 1, search: '' } as never };
}
